import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpWrapper {
  constructor(private http: HttpClient) { }

  get<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    return this.http.get<T>(url, {
      headers,
      params,
      observe: 'response'
    });
  }


  getReport(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<any> {
    return this.http.request('GET', url, {
      headers,
      params,
      observe: 'response',
      responseType: 'arraybuffer'
    })
  }

  getText(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<any> {
    return this.http.request('GET', url, {
      headers,
      params,
      observe: 'response',
      responseType: 'text'
    });
  }


  post<T>(url: string, body: any, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    return this.http.post<T>(url, body, {
      headers,
      observe: 'response'
    });
  }



  postText(url: string, body: any, headers?: HttpHeaders): Observable<string> {
    return this.http.post(url, body, {
      headers,
      responseType: 'text' as const // ✔ Correct way
    });
  }


  patch<T>(url: string, body: any = null, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    return this.http.patch<T>(url, body, {
      headers,
      observe: 'response'
    });
  }

  put<T>(url: string, body: any, headers?: HttpHeaders): Observable<HttpResponse<T>> {
    return this.http.put<T>(url, body, {
      headers,
      observe: 'response'
    });
  }

  delete<T>(
    url: string,
    options?: {
      headers?: HttpHeaders;
      params?: HttpParams;
    }
  ): Observable<HttpResponse<T>> {
    return this.http.delete<T>(url, {
      headers: options?.headers,
      params: options?.params,
      observe: 'response'
    });
  }
}
